import jfetch from '@jontetz/jfetch';

export function getPressReleases(data) {
    return jfetch.get('/api/inspiration/pressreleases', data);
}

export function getPressReleasesBySearch(data) {
    return jfetch.get('/api/search/pressreleases', data);
}